import { render } from "./SalonProfile.vue?vue&type=template&id=b559acc8&scoped=true"
import script from "./SalonProfile.vue?vue&type=script&lang=js"
export * from "./SalonProfile.vue?vue&type=script&lang=js"

import "./SalonProfile.vue?vue&type=style&index=0&id=b559acc8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b559acc8"]])

export default __exports__